import React, { Component } from 'react';
import Summarizer from '../components/Summarizer';
import { getDiploGetterBookmarklet } from '../utils/bookmarklet';

class SummaryPage extends Component {
    render() {
        return (
            <div className='summary-container'>
                <div className='summary-header'>
                    <h1>
                        Diplo Summarizer
                    </h1>
                    <h4>
                        Prepare content for AI summarisation
                    </h4>
                    <a
                        href={getDiploGetterBookmarklet()}
                        title="Drag this button to your bookmarks bar. Click it on any article to open it in the Diplo Summarizer."
                        onClick={(e) => e.preventDefault()}
                        style={{
                            display: "inline-block",
                            alignSelf: "flex-start",
                            width: "fit-content",
                            marginTop: "10px",
                            padding: "8px 16px",
                            backgroundColor: "#00879a",
                            color: "#fff",
                            borderRadius: "4px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            cursor: "grab"
                        }}
                    >
                        Diplo Get It - Bookmark
                    </a>
                </div>
                <div className='summary-body'>
                    <Summarizer />
                </div>
            </div>
        );
    }
}

export default SummaryPage;